// LogOut.jsx

import React from "react";

import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import LogoutIcon from "@mui/icons-material/Logout";

import { supabase } from "../../supabaseClient";
import { marginFab, separationFab, zIndexBotones } from "./helpers";

const LogOut = ({ afterSignOut, fabNumber = 0 }) => {
    const handleLogout = async () => {
        // Call Supabase signOut
        const { error } = await supabase.auth.signOut();
        if (error) {
            console.error("Error signing out:", error.message);
            // Optionally show a toast/snackbar here
            return;
        }
        // Optional callback after successful sign-out (e.g., navigate("/login"))
        if (afterSignOut) afterSignOut();
    };

    return (
        <Tooltip title="Log out">
            <Fab
                aria-label="log out"
                onClick={handleLogout}
                color="primary"
                sx={{
                    position: "fixed",
                    left: marginFab,
                    top: marginFab + separationFab * fabNumber,
                    zIndex: zIndexBotones, // keep it above drawers/app bars
                }}
            >
                <LogoutIcon />
            </Fab>
        </Tooltip>
    );
};

export default LogOut;
